import React from "react";
import { DataManProps } from "./DataMan.types";
import { DataManBody } from "./components/DataManBody";
import { DataManProvider } from "./providers/DataManProvider";
import { DataManDataBase } from "./types/common";

/**
 * The data table of settings and admin pages: columns with custom cells, row actions with
 * confirmation, bulk selection, reordering, grouping, a hierarchy of nodes with their rows,
 * load more and virtualization. Under the `md` breakpoint it shows a list of cards.
 *
 * Options are read when it mounts (except `data`, `columns`, the actions and the load-more
 * props): give it a new `key` to apply other options.
 */
export function DataMan<TData extends DataManDataBase, TValue>(
  props: DataManProps<TData, TValue>
) {
  const { ...initialState } = props;

  return (
    <DataManProvider {...initialState}>
      <DataManBody />
    </DataManProvider>
  );
}
